export default __webpack_public_path__ + "static/media/logo-vector.a7a246f3.svg";